var _use, _defs, _symbol;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 2.5,
    y: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#070135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#612d50"
  })))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "B",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 12.308C80 4.923 73.846 0 66.462 0H13.539C6.154 0 0 4.923 0 12.308v55.385C0 75.077 6.154 80 13.539 80h52.923C73.846 80 80 75.077 80 67.692z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.438 34.265c2.066 0 3.632-.454 4.699-1.362s1.6-2.247 1.6-4.018c0-1.748-.533-3.076-1.6-3.984-1.067-.931-2.633-1.396-4.699-1.396h-7.252v10.759h7.252m.443 22.234c2.633 0 4.608-.556 5.925-1.668 1.339-1.112 2.009-2.792 2.009-5.039 0-2.202-.658-3.847-1.975-4.937-1.317-1.112-3.303-1.668-5.959-1.668h-7.695v13.313h7.695m12.19-18.284c2.815.817 4.994 2.327 6.537 4.528s2.315 4.903 2.315 8.104c0 4.903-1.657 8.558-4.971 10.964s-8.353 3.609-15.118 3.609H19.077V14.585h19.68c7.059 0 12.167 1.067 15.322 3.201 3.178 2.134 4.767 5.55 4.767 10.249 0 2.474-.579 4.585-1.736 6.333-1.158 1.725-2.838 3.008-5.039 3.848"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.08b5ddcd32f41376d4681d52da9297fd.svg";
export { ForwardRef as ReactComponent };